var _defs, _g, _circle, _circle2, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg02RpGlass(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    width: 128,
    height: 128,
    role: "img",
    "aria-label": "RendPleX AI Advisor \\u2014 RP monogram, soft glass",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "RendPleX AI Advisor \u2014 RP monogram (soft glass)") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "rpg-bg",
    cx: "35%",
    cy: "28%",
    r: "85%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#3E8BE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55%",
    stopColor: "#154C93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0A2450"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "rpg-glow",
    cx: "82%",
    cy: "88%",
    r: "55%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#34D399",
    stopOpacity: 0.65
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "60%",
    stopColor: "#10B981",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#10B981",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rpg-shine",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFFFFF",
    stopOpacity: 0.42
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55%",
    stopColor: "#FFFFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rpg-text",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#DCEBFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "rpg-clip"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 64,
    r: 62
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#rpg-clip)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 64,
    r: 62,
    fill: "url(#rpg-bg)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 64,
    r: 62,
    fill: "url(#rpg-glow)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 64,
    cy: 16,
    rx: 62,
    ry: 28,
    fill: "url(#rpg-shine)"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 64,
    r: 61,
    fill: "none",
    stroke: "#FFFFFF",
    strokeOpacity: 0.22,
    strokeWidth: 1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 64,
    r: 59.5,
    fill: "none",
    stroke: "#000000",
    strokeOpacity: 0.18,
    strokeWidth: 1
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 64,
    y: 83,
    textAnchor: "middle",
    fontFamily: "'Inter', 'SF Pro Display', system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif",
    fontWeight: 700,
    fontSize: 54,
    fill: "url(#rpg-text)",
    letterSpacing: -2.5
  }, "RP")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg02RpGlass);
export default __webpack_public_path__ + "static/media/02-rp-glass.692338ef43f58ce8ebfe9a027ce14611.svg";
export { ForwardRef as ReactComponent };